"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPayInDetails = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useGetPayInDetails = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.PAY_IN_GET_DETAILS,
    }), data = _c.data, mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        getMakePayInDetails: mutate,
        isSubmitting: isSubmitting,
        error: error,
        data: data,
    }); }, [mutate, isSubmitting, error, data]);
};
exports.useGetPayInDetails = useGetPayInDetails;
